import { render } from "./NotFound.vue?vue&type=template&id=57bcdad3"
const script = {}
script.render = render

export default script